import type {
  AlunoDaTurma,
  Turma,
} from "../types";

import {
  useState,
} from "react";

import HistoricoTurma from "./HistoricoTurma";

import HistoricoAluno from "./HistoricoAluno";

import PacoteAluno from "./PacoteAluno";

import ChamadaTurma from "./ChamadaTurma";

import "./TurmaDetalhes.css";


type TurmaDetalhesProps = {
  turma: Turma;

  alunos: AlunoDaTurma[];

  loading: boolean;

  canManage: boolean;

  onVoltar: () => void;

  onAdicionarAluno: () => void;

  onRemoverAluno: (
    aluno: AlunoDaTurma,
  ) => void;
};


function formatDias(
  dias: string[],
) {
  return dias.join(", ");
}


export default function TurmaDetalhes({
  turma,
  alunos,
  loading,
  canManage,
  onVoltar,
  onAdicionarAluno,
  onRemoverAluno,
}: TurmaDetalhesProps) {

  const [
    chamadaDate,
    setChamadaDate,
  ] =
    useState<string | null>(
      null,
    );

    const [
  chamadaAberta,
  setChamadaAberta,
] =
  useState(
    true,
  );

    const [
  pacoteRefreshKey,
  setPacoteRefreshKey,
] =
  useState(0);


  const [
    historicoAlunoAberto,
    setHistoricoAlunoAberto,
  ] =
    useState<string | null>(
      null,
    );


  return (
    <section className="turma-detalhes">
      <div className="turma-detalhes-header">
        <button
          type="button"
          className="turma-back-button"
          onClick={onVoltar}
        >
          ← Voltar
        </button>

        <span className="turma-status turma-status-active">
          Ativa
        </span>
      </div>


      <div className="turma-detalhes-title">
        <span className="turmas-eyebrow">
          TURMA
        </span>

        <h2>
          {turma.nome}
        </h2>

        <p>
          {turma.professor ||
            "Professor não informado"}
          {" • "}
          {formatDias(
            turma.dias,
          )}
          {" • "}
          {turma.hora}
          {" • "}
          {turma.quadra_nome ||
            "Quadra não definida"}
        </p>
      </div>

      {chamadaAberta && (
  <ChamadaTurma
    turma={
      turma
    }

    alunos={
      alunos
    }

    canManage={
      canManage
    }

    externalDate={
      chamadaDate
    }

    refreshKey={
      pacoteRefreshKey
    }

    onConfirmSuccess={() => {
      setPacoteRefreshKey(
        (current) =>
          current + 1,
      );

      setChamadaAberta(
        false,
      );

      setChamadaDate(
        null,
      );
    }}
  />
)}


      <div className="turma-detalhes-card">
        <div className="turma-alunos-header">
          <div>
            <span className="turmas-eyebrow">
              ALUNOS
            </span>

            <h3>
              Alunos da turma
            </h3>
          </div>

          <div className="turma-alunos-count">
            <strong>
              {alunos.length}
            </strong>

            <span>
              {" / "}
              {turma.capacidade}
            </span>
          </div>
        </div>


        {loading ? (
          <div className="turmas-empty">
            Carregando alunos...
          </div>
        ) : alunos.length === 0 ? (
          <div className="turmas-empty">
            <strong>
              Nenhum aluno nesta turma.
            </strong>

            <span>
              Adicione o primeiro aluno
              para começar o controle
              das aulas.
            </span>
          </div>
        ) : (
          <div className="turma-alunos-list">
            {alunos.map(
  (item) => (
    <div
      key={
        item.vinculo_id
      }
      className="turma-aluno-wrapper"
    >
      <div className="turma-aluno-item">
        <div className="turma-aluno-main">
          <strong>
            {item.aluno.nome}
          </strong>

          <span>
            Nível{" "}
            {item.aluno.nivel}
          </span>
        </div>


        <div className="turma-aluno-contact">
          {item.aluno.telefone ||
            "Sem telefone"}
        </div>


        {canManage && (
          <button
            type="button"
            className="turma-remove-aluno"
            onClick={() =>
              onRemoverAluno(
                item,
              )
            }
          >
            Remover
          </button>
        )}
      </div>


      <PacoteAluno
        aluno={
          item.aluno
        }
        turmaId={
          turma.id
        }
        canManage={
          canManage
        }

        refreshKey={
  pacoteRefreshKey
}

        onPacoteChange={() =>
  setPacoteRefreshKey(
    (current) =>
      current + 1,
  )
}
      />
      <button
  type="button"
  className="turma-historico-toggle"
  onClick={() =>
    setHistoricoAlunoAberto(
      (current) =>
        current ===
          item.aluno.id
          ? null
          : item.aluno.id,
    )
  }
>
  {historicoAlunoAberto ===
  item.aluno.id
    ? "Ocultar histórico do aluno"
    : "Ver histórico do aluno"}
</button>


{historicoAlunoAberto ===
  item.aluno.id && (
  <HistoricoAluno
    aluno={
      item.aluno
    }
    turmaId={
      turma.id
    }
    refreshKey={
  pacoteRefreshKey
}
    onAbrirChamada={(
      data,
    ) => {
      setChamadaDate(
        data,
      );

      setChamadaAberta(
  true,
);

      window.scrollTo({
        top: 0,
        behavior:
          "smooth",
      });
    }}
  />
)}
    </div>
  ),
)}
          </div>
        )}


        {canManage && (
          <button
            type="button"
            className="turmas-primary-button turma-add-aluno"
            onClick={
              onAdicionarAluno
            }
            disabled={
              alunos.length >=
              turma.capacidade
            }
          >
            + Adicionar aluno
          </button>
        )}


        {alunos.length >=
          turma.capacidade && (
          <div className="turma-capacity-warning">
            Esta turma atingiu a
            capacidade máxima de{" "}
            {turma.capacidade} alunos.
          </div>
        )}
      </div>

      <HistoricoTurma
  turmaId={
    turma.id
  }
  refreshKey={
  pacoteRefreshKey
}
  onAbrirChamada={(
    data,
  ) => {
    setChamadaDate(
      data,
    );

    setChamadaAberta(
  true,
);

    window.scrollTo({
      top: 0,
      behavior:
        "smooth",
    });
  }}
/>
    </section>
  );
}